/**
 * La configuración de Mermaid, una sola para la vista previa (navegador) y el PDF (Chromium del
 * worker): con la misma librería y las mismas opciones, el mismo código da el mismo dibujo.
 *
 * - `securityLevel: "strict"`: los textos del diagrama se escapan; el SVG resultante se
 *   inyecta en la hoja tal cual y nadie puede meter HTML a través de un flujograma.
 * - `htmlLabels: false`: las etiquetas van como texto SVG, no como `foreignObject`; se imprime
 *   igual en Chromium y se ve igual en cualquier visor de PDF.
 * - Times New Roman, la fuente del documento.
 */
export const OPCIONES_MERMAID = {
  startOnLoad: false,
  securityLevel: "strict",
  theme: "neutral",
  fontFamily: '"Times New Roman", Times, serif',
  fontSize: 14,
  flowchart: { htmlLabels: false, useMaxWidth: true, curve: "linear" },
  sequence: { useMaxWidth: true },
  logLevel: "fatal",
} as const;

/** El id del SVG de un bloque, válido como id de elemento (Mermaid lo exige). */
export function idDeSvg(bloqueId: string): string {
  return `flujo-${bloqueId.replace(/[^A-Za-z0-9_-]/g, "")}`;
}

/** Lo que se muestra en el lugar de un diagrama que no se pudo dibujar. */
export function mensajeDeErrorMermaid(e: unknown): string {
  const texto = e instanceof Error ? e.message : String(e);
  // Mermaid describe el error en varias líneas; la primera es la que sirve.
  return texto.split("\n")[0]?.slice(0, 200) ?? "Error en el diagrama";
}
